export default __webpack_public_path__ + "356d80b2dbcb225b79d366af0a790b62.png";